"use strict";
/* eslint-disable @typescript-eslint/no-redeclare */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IX_TITLES = exports.IX_STRUCTS = exports.StakeInstructionType = exports.MergeInfo = exports.DeactivateInfo = exports.WithdrawInfo = exports.SplitInfo = exports.AuthorizeInfo = exports.DelegateInfo = exports.InitializeInfo = void 0;
const superstruct_1 = require("superstruct");
const pubkey_1 = require("../../validators/pubkey");
exports.InitializeInfo = (0, superstruct_1.type)({
    stakeAccount: pubkey_1.PublicKeyFromString,
    authorized: (0, superstruct_1.type)({
        staker: pubkey_1.PublicKeyFromString,
        withdrawer: pubkey_1.PublicKeyFromString,
    }),
    lockup: (0, superstruct_1.type)({
        unixTimestamp: (0, superstruct_1.number)(),
        epoch: (0, superstruct_1.number)(),
        custodian: pubkey_1.PublicKeyFromString,
    }),
});
exports.DelegateInfo = (0, superstruct_1.type)({
    stakeAccount: pubkey_1.PublicKeyFromString,
    voteAccount: pubkey_1.PublicKeyFromString,
    stakeAuthority: pubkey_1.PublicKeyFromString,
});
exports.AuthorizeInfo = (0, superstruct_1.type)({
    authorityType: (0, superstruct_1.string)(),
    stakeAccount: pubkey_1.PublicKeyFromString,
    authority: pubkey_1.PublicKeyFromString,
    newAuthority: pubkey_1.PublicKeyFromString,
});
exports.SplitInfo = (0, superstruct_1.type)({
    stakeAccount: pubkey_1.PublicKeyFromString,
    stakeAuthority: pubkey_1.PublicKeyFromString,
    newSplitAccount: pubkey_1.PublicKeyFromString,
    lamports: (0, superstruct_1.number)(),
});
exports.WithdrawInfo = (0, superstruct_1.type)({
    stakeAccount: pubkey_1.PublicKeyFromString,
    withdrawAuthority: pubkey_1.PublicKeyFromString,
    destination: pubkey_1.PublicKeyFromString,
    lamports: (0, superstruct_1.number)(),
});
exports.DeactivateInfo = (0, superstruct_1.type)({
    stakeAccount: pubkey_1.PublicKeyFromString,
    stakeAuthority: pubkey_1.PublicKeyFromString,
});
exports.MergeInfo = (0, superstruct_1.type)({
    source: pubkey_1.PublicKeyFromString,
    destination: pubkey_1.PublicKeyFromString,
    stakeAuthority: pubkey_1.PublicKeyFromString,
    stakeHistorySysvar: pubkey_1.PublicKeyFromString,
    clockSysvar: pubkey_1.PublicKeyFromString,
});
exports.StakeInstructionType = (0, superstruct_1.enums)([
    "initialize",
    "delegate",
    "authorize",
    "split",
    "withdraw",
    "deactivate",
    "merge",
]);
exports.IX_STRUCTS = {
    initialize: exports.InitializeInfo,
    delegate: exports.DelegateInfo,
    authorize: exports.AuthorizeInfo,
    split: exports.SplitInfo,
    withdraw: exports.WithdrawInfo,
    deactivate: exports.DeactivateInfo,
    merge: exports.MergeInfo,
};
exports.IX_TITLES = {
    initialize: "Initialize",
    delegate: "Delegate",
    authorize: "Authorize",
    split: "Split",
    withdraw: "Withdraw",
    deactivate: "Deactive",
    merge: "Merge",
};
//# sourceMappingURL=types.js.map